module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/barcode-read-cb081063aa97085c24aae8bce0c6c1e1.svg";